/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { Text, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing } from '../../../shared/theme/spacing';
import { ticketColors } from '../../../shared/theme/ticketColors';

type Props = {
  /** Última actualización ISO string (null = pendiente). */
  lastUpdatedAt?: string | null;
  /** Texto corto de fuente de datos (vacío = todo desde servidor). */
  dataSourceHint?: string;
};

/**
 * Metadato compacto de origen/actualización, compartido por las 4 pestañas de Informes.
 * Muestra icono + "Actualizado: HH:mm" + fuente (servidor / esta compu).
 */
export function ReportsDataSourceFooter({ lastUpdatedAt, dataSourceHint }: Props) {
  const timeLabel = formatFooterTime(lastUpdatedAt);
  const showHint = !!dataSourceHint && dataSourceHint.length > 0;

  return (
    <View style={footerStyles.container}>
      <Ionicons name="cloud-done-outline" size={13} color={ticketColors.ink3} />
      <Text style={footerStyles.text}>{timeLabel}</Text>
      {showHint ? (
        <>
          <Text style={footerStyles.separator}>·</Text>
          <Ionicons name="warning-outline" size={12} color={ticketColors.gold} />
          <Text style={[footerStyles.text, { color: ticketColors.gold }]}>{dataSourceHint}</Text>
        </>
      ) : null}
    </View>
  );
}

function formatFooterTime(iso: string | null | undefined): string {
  if (!iso) return 'Actualización pendiente';
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return 'Actualización pendiente';
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `Actualizado: ${hh}:${mm}`;
  } catch {
    return 'Actualización pendiente';
  }
}

const footerStyles = {
  container: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    flexWrap: 'wrap' as const,
    gap: 6,
    paddingVertical: spacing.xs,
    paddingHorizontal: spacing.sm,
    opacity: 0.85,
  },
  text: {
    fontSize: 11,
    lineHeight: 14,
    color: ticketColors.ink3,
    fontWeight: '600' as const,
    flexShrink: 1,
  },
  separator: {
    fontSize: 11,
    color: ticketColors.ink3,
  },
};
